import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES) },
      { path: 'products', loadChildren: () => import('./features/products/products.routes').then(m => m.PRODUCTS_ROUTES) },
      { path: 'stock', loadChildren: () => import('./features/stock/stock.routes').then(m => m.STOCK_ROUTES) },
      { path: 'sales', loadChildren: () => import('./features/sales/sales.routes').then(m => m.SALES_ROUTES) },
      { path: 'clients', loadChildren: () => import('./features/clients/clients.routes').then(m => m.CLIENTS_ROUTES) },

      // ADMIN & MANAGER
      { path: 'expenses',   canActivate: [roleGuard('ADMIN', 'MANAGER')], loadChildren: () => import('./features/expenses/expenses.routes').then(m => m.EXPENSES_ROUTES) },
      { path: 'suppliers',  canActivate: [roleGuard('ADMIN', 'MANAGER')], loadChildren: () => import('./features/suppliers/suppliers.routes').then(m => m.SUPPLIERS_ROUTES) },
      { path: 'objectives', canActivate: [roleGuard('ADMIN', 'MANAGER')], loadChildren: () => import('./features/objectives/objectives.routes').then(m => m.OBJECTIVES_ROUTES) },
      { path: 'campaigns',  canActivate: [roleGuard('ADMIN', 'MANAGER')], loadChildren: () => import('./features/campaigns/campaigns.routes').then(m => m.CAMPAIGNS_ROUTES) },

      // ADMIN ONLY
      { path: 'commercials', canActivate: [roleGuard('ADMIN')], loadChildren: () => import('./features/commercials/commercials.routes').then(m => m.COMMERCIALS_ROUTES) },
      { path: 'settings',   canActivate: [roleGuard('ADMIN')], loadChildren: () => import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES) }
    ]
  },
  { path: '**', redirectTo: '' }
];
